import { Component } from '@angular/core';
import { Benefit } from '../../../models/benefit';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { findBenefitCatalogAct, saveBenefitCatalogAct, updateBenefitCatalogAct } from '../../../store/benefit-catalog/benefit-catalog.action';
import { BenefitType } from '../../../models/benefit-type';
import { findBenefitTypeCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';

@Component({
  selector: 'app-benefit-catalog-edit',
  standalone: false,
  templateUrl: './benefits-catalog-edit.component.html',
  styleUrl: './benefits-catalog-edit.component.css'
})
export class BenefitCatalogEditComponent {

  benefitCatForm!: NgForm;
  loading = false;
  title!: string;
  benefit: Benefit = new Benefit();
  violations: any;
  benefitTypes: BenefitType[] = [];

  constructor(
    private route: ActivatedRoute,
    private benefitStore: Store<{benefitCatalogRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ) {
    this.benefitStore.pipe(
      select('benefitCatalogRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        benefit: state.benefit,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ benefit, violations, loading }) => {
      //this.benefit = benefit;
      this.benefit = JSON.parse(JSON.stringify(benefit));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Benefico';

      if(this.benefitCatForm){
      
        Object.keys(this.benefitCatForm.controls).forEach(controlName => {
          const control = this.benefitCatForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        benefitTypes: state.benefitTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ benefitTypes }) => {
      //this.benefitTypes = benefitTypes;
      this.benefitTypes = JSON.parse(JSON.stringify(benefitTypes));
    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.benefitStore.dispatch(findBenefitCatalogAct({ id }));
      }else{
        this.benefit = new Benefit();
        this.benefit.active = true;
        this.loading = false;
        this.title = 'Agregar Beneficio';
      }
    });

    this.catalogOfferStore.dispatch(findBenefitTypeCatalogAct());
  }

  onSubmitBenefir(benefitCatForm: NgForm): void {
    //this.loading = true;
    this.benefitCatForm = benefitCatForm;
    const benefitCopy = JSON.parse(JSON.stringify(this.benefit));
   
    if (benefitCopy.id > 0) {
      this.benefitStore.dispatch(updateBenefitCatalogAct({ benefitUpdated: benefitCopy }))
    } else {
      this.benefitStore.dispatch(saveBenefitCatalogAct({ benefitNew: benefitCopy }))
    }
  }

  compareBenefitTypes = (a: any, b: any) => a?.id === b?.id;
  removeSpaces() {
    this.benefit.attribute = (this.benefit.attribute ?? '').replace(/\s+/g, '');
  }  
  
}
